var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-471 272.2 16.8 16.8",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-460.5 280.6l5.8-5.8c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0l-5.8 5.8-5.8-5.9c-.6-.5-1.6-.5-2.2 0s-.6 1.5 0 2.1l5.8 5.8-5.8 5.8c-.6.6-.6 1.5 0 2.1.3.3.7.4 1.1.4s.8-.1 1.1-.4l5.8-5.8 5.8 5.8c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.6-.6.6-1.5 0-2.1l-5.9-5.7z"
  })));
}

export default SvgClosex;